import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '@environments/environment'
import { map, Observable } from 'rxjs'
import {
  ApiToken,
  ApiTokenListParams,
  ApiTokenListResult,
  ApiTokenPaginatedResponse,
  ApiTokenResponse,
  CreateApiToken,
  CreateApiTokenResponse,
  UpdateApiToken,
  UpdateApiTokenResponse
} from '../enums/api-tokens.model'

@Injectable()
export class ApiKeyService {
  constructor(private http: HttpClient) {}

  getApiKeys(organizationId: number, params: ApiTokenListParams): Observable<ApiTokenListResult> {
    let httpParams = new HttpParams().set('page', params.page).set('per_page', params.per_page)

    return this.http.get<ApiTokenPaginatedResponse>(`${environment.integrationsApi}api-tokens/organization/${organizationId}`, { params: httpParams }).pipe(
      map((response) => ({
        items: response.data,
        current_page: response.pagination.current_page,
        last_page: response.pagination.last_page
      }))
    )
  }

  getApiKey(tokenId: number): Observable<ApiToken> {
    return this.http.get<ApiTokenResponse>(`${environment.integrationsApi}api-tokens/${tokenId}`).pipe(map((response) => response.data))
  }

  createApiKey(payload: CreateApiToken): Observable<CreateApiTokenResponse> {
    return this.http.post<CreateApiTokenResponse>(`${environment.integrationsApi}api-tokens`, payload)
  }

  updateApiKey(tokenId: number, payload: UpdateApiToken): Observable<UpdateApiTokenResponse> {
    return this.http.patch<UpdateApiTokenResponse>(`${environment.integrationsApi}api-tokens/${tokenId}`, payload)
  }

  deleteApiKey(tokenId: number): Observable<void> {
    return this.http.delete<void>(`${environment.integrationsApi}api-tokens/${tokenId}`)
  }

  rotateApiKey(tokenId: number): Observable<CreateApiTokenResponse> {
    return this.http.post<CreateApiTokenResponse>(`${environment.integrationsApi}api-tokens/rotate/${tokenId}`, {})
  }
}
